import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import useAuth from 'src/hooks/useAuth';
import { logoutRedirect } from 'src/services/gigya/gigya-service';
import { AuthStatus } from 'src/types';
import { AuthenticatedLayout } from '../Layout';
import { routes } from '../Pages';

const ProtectedRoute: Route = ({
  component: Component,
  onlyDelegate,
  ...rest
}) => {
  const {
    user,
    status,
    isDelegate,
    isSSHUser,
    hasSSHInParentOrg,
    hasDelegateInParentOrg,
    isPDAUser,
  } = useAuth();

  const isBookingsPage =
    rest.path === routes.ProfessionalDevelopmentApprovals.path;

  const shouldRedirectDelegateRoute =
    onlyDelegate &&
    !isDelegate &&
    !isSSHUser &&
    !hasSSHInParentOrg &&
    !hasDelegateInParentOrg;

  if (
    user &&
    (status === AuthStatus.Authenticated || status === AuthStatus.Loading)
  ) {
    return (
      <AuthenticatedLayout>
        <Route component={Component} {...rest}>
          {((!isPDAUser && isBookingsPage) || shouldRedirectDelegateRoute) && (
            <Redirect to={routes.Home.path} />
          )}
        </Route>
      </AuthenticatedLayout>
    );
  }

  if (status === AuthStatus.Unauthenticated) {
    logoutRedirect();
  }

  return null;
};

export default ProtectedRoute;
